import { useEffect, useState } from "react";
import { capitalizeWords, isArabic, isValidUAENumber } from "../../utils/util";
import { getMoblieNumberLoginUser } from "../../services/liferay/common";
import { getLookupItemData } from "../../services/epic/medicalReport";

const UserInfo = ({
  userDetails,
  alternateNumber,
  setAlternateNumber,
  translationMap,
  setIsContinuePayment,
  relationship,
  showRelationship,
  setRelationShip
}) => {
  const [showAlternateNumber, setShowAlternateNumber] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [relationShipsOption, setRelationShipsOption] = useState([]);

  useEffect(() => {
    getRelationshipData();
  }, []);
  const handleChange = () => {
    setShowAlternateNumber(!showAlternateNumber);
    setAlternateNumber("");
    setErrorMessage("");
  };

  const getRelationshipData = () => {
    const lookItemRequestBody = { "groupName": "relation" };
    getLookupItemData(lookItemRequestBody).then((result) => {
      // console.log("Look up item  Result ", result);
      setRelationShipsOption(result.data);
    });
  };
  // let relationShipsOption = ["Wife", "Husband", "Son", "Daughter", "Father", "Mother", "Other"];
  let mobileNumber = "+971 " + getMoblieNumberLoginUser();
  const inputChangeAlternateNumber = (e) => {
    let value = e.target.value;
    // Allow only digits and "+" for international format
    if (/^\+?\d*$/.test(value)) {
      setAlternateNumber(value);
      if (value.length === 0) {
        setErrorMessage(translationMap?.mobileNoRequired);
        setIsContinuePayment(false);
      } else if (isValidUAENumber(value)) {

        setErrorMessage("");
        setIsContinuePayment(true);
      } else {
        setErrorMessage(translationMap?.invalidUaeNumber);
        setIsContinuePayment(false);
      }
    } else {
      setErrorMessage(translationMap?.ErrorValidChar);
      setIsContinuePayment(false);
    }
  };


  return (
    <>
            <div className="Inner_Box">
                <div className="input_field_box">
                    <h6 className="Gray_Title Gray_Title2">
                        {translationMap?.patientInformation}
                    </h6>
                    <div className="input_inner_box">
                        <div className="row ">
                            <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box">
                                    <label htmlFor="html">{translationMap?.requestingMedicalReportFor}</label>
                                    <input type="text" name="name" disabled placeholder="Enter your name"
                  className="input_field disable_field"
                  value={capitalizeWords(`${userDetails?.PatientFirstName ?? ""} ${userDetails?.patientLastName ?? ""}`)} />
                                </div>

                            </div>
                            {showRelationship &&
              <div className="col-12 col-md-12 col-lg-6">
                                    <div className="custom_input_box">
                                        <label htmlFor="html">{translationMap?.selectRelationship}</label>
                                        <div className="select_custom_box" id="selectRelationShipId">
                                            <div className="dropdown-form">
                                                <select
                        id="relationship"
                        className="selectDropdown"
                        value={relationship}
                        onChange={(e) => setRelationShip(e.target.value)}>
                        
                                                    <option value="" disabled>
                                                        {translationMap?.select_relationship}
                                                    </option>
                                                    {relationShipsOption.map((item, index) =>
                        <option key={index}
                        value={item?.nameEnglish?.toLowerCase()}>
                                                            {isArabic() ? item?.nameArabic : item?.nameEnglish}

                                                        </option>
                        )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
              }
                        </div>
                    </div>
                </div>
            </div>
            <div className="Inner_Box">
                <div className="input_field_box">
                    <h6 className="Gray_Title Gray_Title2">
                        {translationMap?.contactInformation}
                    </h6>
                    <div className="input_inner_box">
                        <div className="row ">
                            <div className="col-12 col-md-12 col-lg-6">
                                <div className="custom_input_box ">
                                    <label for="html">{translationMap?.mobileNumber}</label>
                                    <input style={{ direction: 'ltr' }} type="number" name="name" disabled
                  placeholder={`${mobileNumber}`}
                  className="input_field disable_field"
                  value={`${getMoblieNumberLoginUser() || ''}`} />
                                    <div className="custom_check_box">
                                        <input type="checkbox" className="checkboxField" id="checkbox2"
                    onClick={handleChange} />
                                        <label for="checkbox2">{translationMap?.addAltMobileNumber}</label>
                                    </div>
                                </div>
                            </div>
                            {showAlternateNumber &&
              <div className="col-12 col-md-12 col-lg-6">
                                    <div className="custom_input_box ">
                                        <label for="html">{translationMap?.altMobileNumber}
                                            <button type="button" className="tooltip_box" data-toggle="tooltip"
                    data-placement="top" title="Tooltip on top">
                                                <i className="material-symbols-outlined">
                                                    info
                                                </i>
                                            </button>
                                        </label>
                                        <input type="tel" name="name" onChange={inputChangeAlternateNumber}
                  placeholder={'+971 5X XXX XX XX'}
                  className="input_field" value={alternateNumber}
                  style={{
                    borderColor: errorMessage ?
                    "#FF8F8A" :
                    "rgb(128 153 178)"
                  }} />
                  
                                        {errorMessage &&
                  <span id="text" style={{ color: "#FF8F8A" }}>
                                  {errorMessage}
                                </span>
                  }
                                    </div>
                                </div>
              }
                        </div>
                    </div>
                </div>
            </div>
        </>);

};

export default UserInfo;